module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/manual-placement.374778eb.svg";